<template>
  <div :class="['definition-wrapper', 'chart', 'combo-chart', {'error_validate': mandatoryValidation}]">
    <GChart v-if="componentMounted"
      type="ComboChart"
      :data="chartData"
      :options="chartOptions"
      :settings="chartSettings"
    />
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts'
import transport from 'vue-definition-utils/src/utils/transport'
import language from '../../language'

export default {
  name: 'definition-combo-chart',
  props: [
    'definition',
    'object',
    'definitionObject',
    'editable',
    'mandatoryValidation',
    'definitionId',
    'definitionContentId',
    'repeatableGroupCode',
    'requestObjectForAdd',
    'requestObjectForAddModified',
    'visualDefinition',
    'language',
    'callTask'
  ],
  components: {
    GChart
  },
  data () {
    return {
      componentMounted: false,
      chartData: [],
      chartOptions: {},
      chartSettings: {}
    }
  },
  methods: {
    getDefinitionHeight () {
      var definition = this.visualDefinition.getDefinitionFields(this.definition.id)
      return definition.height
    }
  },
  beforeMount () {
    this.object.chartValue = {
      region: null,
      header: [
        {
          type: 'string',
          label: 'Mes'
        },
        {
          type: 'number',
          label: 'Bajas'
        },
        {
          type: 'number',
          label: 'Total'
        },
        {
          type: 'number',
          label: 'Diferencia'
        }
      ],
      data: [
        ['Enero', -165, 938, parseInt(938 - 165)],
        ['Febrero', -1535, 1120, parseInt(1120 - 135)],
        ['Marzo', -157, 1167, parseInt(1167 - 157)],
        ['Abril', -139, 1110, parseInt(1110 - 139)],
        ['Mayo', -136, 691, parseInt(691 - 136)],
        ['Junio', -165, 938, parseInt(938 - 165)],
        ['Julio', -135, 1120, parseInt(1120 - 135)],
        ['Agosto', -157, 1167, parseInt(1167 - 157)],
        ['Septiembre', -139, 1110, parseInt(1110 - 139)],
        ['Octubre', -136, 691, parseInt(691 - 136)],
        ['Noviembre', -139, 1110, parseInt(1110 - 139)],
        ['Diciembre', -136, 691, parseInt(691 - 136)]
      ]
    }
    var dataChart = transport.methods.getDataChart(JSON.parse(JSON.stringify(this.object.chartValue)))
    this.chartData = dataChart.chartData

    this.chartOptions.seriesType = 'bars'
    this.chartOptions.series = {2: {type: 'line'}}
    this.chartOptions.isStacked = true
    this.chartOptions.colors = ['red', '#5DD23C', '#d42e12']
    this.chartOptions.width = '100%'
    this.chartOptions.height = 500
    this.chartOptions.fontSize = 16
    var height = this.getDefinitionHeight()
    if (height) {
      this.chartOptions.height = height
    }

    this.chartSettings.packages = ['corechart']
    this.chartSettings.language = language(this.language, 'chart')

    this.componentMounted = true
  }
}
</script>



// WEBPACK FOOTER //
// src/components/content/definitionLoader/item/chart/comboChart.vue